// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"yJ-z","loadingMedia":"zJ-z","reviewsImagesAndVideos":"AJ-z","limitHeight":"BJ-z"};